<template>
  <div>
    <vx-card>
      <div class="content">
        <vs-row class="mb-6 flex justify-end">
          <vs-col vs-sm="12" vs-lg="4">
              <vs-row>
                <vs-col class="pr-2 flex items-center" vs-sm="12" vs-lg="6">
                  <label>{{$i18n.t('VoucherNumber')}}</label>
                </vs-col>
                <vs-col class="pr-2" vs-sm="12" vs-lg="4">
                  <vs-input class="w-full" v-mask="'NN-NNN'" placeholder="##-###" v-model="fs_number" v-validate="'required'" name="number" />
                </vs-col>
                <vs-col vs-sm="12" vs-lg="2">
                  <vs-input class="w-full" v-model="sc_number" v-validate="'required|max:3|numeric'" name="number" placeholder="000"/>
                </vs-col>
              </vs-row>
              <span class="mt-1 text-danger flex justify-end text-sm" v-show="errors.has('number')">{{ errors.first('number') }}</span>
          </vs-col>
          <vs-col vs-sm="12" vs-lg="3" class="pa-0">
            <vs-row>
              <vs-col class="pl-6 flex items-center" vs-sm="12" vs-lg="5">
                <label>Tanggal</label>
              </vs-col>
              <vs-col class="pr-2" vs-sm="12" vs-lg="7">
                <vs-input class="w-full" v-mask="'##-##'" placeholder="DD-MM" v-model="date" v-validate="'required'" name="date" />
              </vs-col>
            </vs-row>
            <span class="mt-1 text-danger flex justify-end text-sm" v-show="errors.has('date')">{{ errors.first('date') }}</span>
          </vs-col>
        </vs-row>
        <div class="cashflow-panel mt-4 mb-6">
          <div class="flex items-center justify-between">
            <div><h3>Cashflow <small class="text-grey">(Opsional)</small></h3><p class="text-sm text-grey">Aktifkan hanya jika voucher perlu dicatat ke Cashflow.</p></div>
            <vs-switch v-model="cashflowEnabled" />
          </div>
          <div v-if="cashflowEnabled" class="mt-4">
            <label class="font-semibold">Tujuan Cashflow</label>
            <div class="mt-2 flex">
              <vs-radio v-model="cashflowTarget" vs-value="cashbook" class="mr-6" vs-name="cashflow-target-cashbook">Buku Kas</vs-radio>
              <vs-radio v-model="cashflowTarget" vs-value="bank_account" vs-name="cashflow-target-bank">Account Bank</vs-radio>
            </div>

            <div v-if="cashflowTarget === 'cashbook'" class="mt-4">
            <label class="font-semibold">Buku Kas Cashflow</label>

            <p v-if="cashbooksLoading" class="mt-2 text-grey">
              Memuat daftar Buku Kas...
            </p>

            <div v-else-if="cashbooksError" class="mt-2">
              <p class="text-danger">{{ cashbooksError }}</p>
              <vs-button class="mt-2" size="small" type="border" @click="loadCashflowCashbooks(true)">
                Coba Lagi
              </vs-button>
            </div>

            <p v-else-if="cashbooksLoaded && cashbookOptions.length === 0" class="mt-2 text-warning">
              Tidak ada Buku Kas yang tersedia.
            </p>

            <v-select
              v-else
              class="w-full mt-2"
              placeholder="Pilih Buku Kas"
              :options="cashbookOptions"
              :reduce="cashbook => cashbook.value"
              :disabled="cashbooksLoading"
              v-model="selectedCashflowCashbookId"
            />
            </div>

            <div v-else class="mt-4">
              <label class="font-semibold">Account Bank</label>
              <p v-if="bankAccountsLoading" class="mt-2 text-grey">Memuat daftar Account Bank...</p>
              <v-select
                v-else
                class="w-full mt-2"
                placeholder="Pilih Account Bank"
                :options="bankAccountOptions"
                :reduce="account => account.value"
                v-model="selectedBankAccountId"
              />
            </div>

            <div class="mt-4">
              <label class="font-semibold">Jenis Transaksi</label>
              <div class="mt-2 flex">
                <vs-radio v-model="type" vs-value="debit" class="mr-6" vs-name="cashflow-type-debit">
                  Kas Masuk
                </vs-radio>
                <vs-radio v-model="type" vs-value="credit" vs-name="cashflow-type-credit">
                  Kas Keluar
                </vs-radio>
              </div>
            </div>

            <div class="mt-4">
              <label class="font-semibold">Paid To</label>
              <vs-input
                class="w-full mt-2"
                maxlength="191"
                placeholder="Nama penerima/pembayar"
                v-model="paidTo"
              />
            </div>

            <div class="mt-4">
              <label class="font-semibold">Catatan Cashflow <span class="text-grey">(opsional)</span></label>
              <vs-input
                class="w-full mt-2"
                maxlength="191"
                placeholder="Catatan yang tampil pada Voucher Cashflow"
                v-model="cashflowNotes"
              />
            </div>

            <div class="mt-4">
              <label class="font-semibold">Item Cashflow tambahan <span class="text-grey">(opsional)</span></label>
              <p class="text-sm text-grey mt-1">Item jurnal tetap disertakan. Nominal positif menambah dan nominal minus mengurangi total Cashflow.</p>
              <div v-for="(item, index) in cashflowExtraItems" :key="index" class="flex flex-wrap items-end mt-3">
                <vs-input v-model.trim="item.title" label="Keterangan" maxlength="191" class="flex-1 mr-3" />
                <vs-input v-model.number="item.amount" type="number" step="1" label="Jumlah (Rp)" class="mr-3" />
                <vs-button color="danger" type="border" icon-pack="feather" icon="icon-trash" aria-label="Hapus item tambahan" @click="cashflowExtraItems.splice(index, 1)" />
              </div>
              <vs-button class="mt-3" type="border" icon-pack="feather" icon="icon-plus" :disabled="cashflowExtraItems.length >= 100" @click="cashflowExtraItems.push({ title: '', amount: null })">Add Item</vs-button>
              <p class="mt-3">Tambahan: Rp {{ cashflowExtraTotal.toLocaleString('id-ID') }}</p>
              <p class="font-semibold">Total Cashflow: Rp {{ (debit + cashflowExtraTotal).toLocaleString('id-ID') }}</p>
            </div>

            <p class="mt-2 text-sm text-grey">
              Voucher akan dicatat ke {{ cashflowTarget === 'cashbook' ? 'Buku Kas' : 'Account Bank' }} yang dipilih.
            </p>
          </div>
        </div>
        <div class="divider my-2"></div>
        <vs-row class="mt-4" >
          <vs-col class="px-1" vs-sm="12" vs-lg="3">
            <label class="font-semibold">{{$i18n.t('Accounts')}}</label>
          </vs-col>
          <vs-col class="px-1" vs-sm="12" vs-lg="5">
            <label class="font-semibold">{{$i18n.t('Description')}}</label>
          </vs-col>
          <vs-col vs-sm="12" vs-lg="4">
            <vs-row>
              <vs-col class="px-1" vs-sm="12" vs-lg="5">
                <label class="font-semibold">{{$i18n.t('Debit')}}</label>
              </vs-col>
              <vs-col class="px-1" vs-sm="12" vs-lg="5">
                <label class="font-semibold">{{$i18n.t('Credit')}}</label>
              </vs-col>
              <vs-col class="px-1" vs-sm="12" vs-lg="1">
                &nbsp;
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
        <template v-for="(input, k) in inputs">
          <vs-row class="my-2" :key="k">
            <vs-col class="px-1" vs-sm="12" vs-lg="3">
              <v-select class="w-full" :options="accountOptions" :reduce="account => account.value" v-model="input.account_id"></v-select>
            </vs-col>
            <vs-col class="px-1" vs-sm="12" vs-lg="5">
              <vs-input class="w-full" v-model="input.description"/>
            </vs-col>
            <vs-col vs-sm="12" vs-lg="4">
              <vs-row>
                <vs-col class="px-1" vs-sm="12" vs-lg="5">
                  <vs-input class="w-full" v-model="input.debit" name="input.debit" v-money="money" value="0" />
                </vs-col>
                <vs-col class="px-1" vs-sm="12" vs-lg="5">
                  <vs-input class="w-full" v-model="input.credit" name="input.credit" v-money="money"/>
                </vs-col>
                <vs-col class="px-1" vs-sm="12" vs-lg="2">
                  <!-- <vs-button color="danger" type="filled" icon-pack="feather" icon="icon-trash" @click="remove(k)" v-show="k || ( !k && inputs.length > 1)"></vs-button> -->
                  <vs-button class="w-full" color="danger" type="filled" icon-pack="feather" icon="icon-trash" @click="remove(k)"></vs-button>
                </vs-col>
              </vs-row>
            </vs-col>
          </vs-row>
        </template>
        <div class="mt-4 px-1">
          <vs-button class="w-full" color="primary" type="filled" icon-pack="feather" icon="icon-plus" @click="add(k)">{{$i18n.t('AddNewData')}}</vs-button>
        </div>
      </div>

      <div class="divider mt-6 mb-2"></div>
      <vs-row>
        <vs-col class="font-semibold" vs-lg="1">{{$i18n.t('Debit')}}</vs-col>
        <vs-col vs-lg="10">: {{ new Intl.NumberFormat('id-ID').format(debit) }}</vs-col>
      </vs-row>
      <vs-row>
        <vs-col class="font-semibold" vs-lg="1">{{$i18n.t('Credit')}}</vs-col>
        <vs-col vs-lg="10">: {{ new Intl.NumberFormat('id-ID').format(credit) }}</vs-col>
      </vs-row>
      <vs-row>
        <vs-col class="font-semibold" vs-lg="1">{{$i18n.t('Difference')}}</vs-col>
        <vs-col vs-lg="10">: {{ new Intl.NumberFormat('id-ID').format(difference) }}</vs-col>
      </vs-row>
      <div class="divider my-2"></div>

      <div class="vx-row">
        <div class="vx-col w-full mt-2">
          <vs-button icon-pack="feather" class="mt-2" @click="submitData()">{{$i18n.t('SaveData')}}</vs-button>
          <vs-button to="/journal-vouchers" class="ml-4 mt-2" type="border" color="danger">{{$i18n.t('Cancel')}}</vs-button>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { VMoney } from 'v-money'
import { Validator } from 'vee-validate'
import moduleAccount from '@/store/accounts/moduleAccount.js'
import moduleVoucher from '@/store/voucher/moduleVoucher.js'

const dict = {
  custom: {
    number: {
      required: 'No Voucher harus diisi',
      numeric: 'Format No Voucher salah',
      max: 'No Voucher tidak boleh lebih dari 3 digit'
    },
    date: {
      required: () => 'Tanggal Voucher harus diisi'
    }
  }
}
Validator.localize('en', dict)

export default {
  components: {
    vSelect
  },
  directives: { money: VMoney },
  data () {
    return {
      accountOptions: [],
      cashflowEnabled: false,
      cashflowTarget: 'cashbook',
      selectedCashflowCashbookId: null,
      selectedBankAccountId: null,
      cashbookOptions: [],
      bankAccountOptions: [],
      bankAccountsLoading: false,
      cashbooksLoading: false,
      cashbooksLoaded: false,
      cashbooksError: null,
      fs_number: null,
      sc_number: null,
      type: null,
      paidTo: null,
      cashflowNotes: '',
      cashflowExtraItems: [],
      date: null,
      debit: 0,
      credit: 0,
      difference: 0,
      amount: null,
      description: null,
      inputs: [
        {
          account_id  : null,
          description : null,
          debit       : 0,
          credit      : 0
        }
      ],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false /* doesn't work with directive */
      }
    }
  },
  computed: {
    cashflowExtraTotal () {
      return this.cashflowExtraItems.reduce((sum, item) => sum + (Number(item.amount) || 0), 0)
    },
    validateForm () {
      return !this.errors.any() &&
      this.type !== '' &&
      this.paidTo !== '' &&
      this.date !== ''  &&
      this.amount !== null  &&
      this.description !== null
    },
    company () {
      return JSON.parse(localStorage.getItem('activeCompany'))
    }
  },
  watch: {
    inputs: {
      handler (inputs) {
        this.debit = inputs.reduce((total, input) => total + this.parseAmount(input.debit), 0)
        this.credit = inputs.reduce((total, input) => total + this.parseAmount(input.credit), 0)

        this.difference = Math.abs(this.debit - this.credit)
      },
      deep: true
    },
    cashflowTarget (target) {
      if (target === 'cashbook') this.selectedBankAccountId = null
      else this.selectedCashflowCashbookId = null
    }
  },
  methods: {
    parseAmount (value) {
      const amount = parseInt(String(value || 0).replaceAll('.', ''))
      return Number.isNaN(amount) ? 0 : amount
    },
    cashbookTypeLabel (type) {
      const labels = {
        1: 'Kas Kecil',
        2: 'Kas Besar',
        3: 'Kas Campuran'
      }

      return labels[type] || 'Cashbook'
    },
    cashbookErrorMessage (error) {
      if (error.response && error.response.data && error.response.data.message) {
        return error.response.data.message
      }

      return 'Daftar Buku Kas tidak dapat dimuat. Silakan coba lagi.'
    },
    loadCashflowCashbooks (force) {
      if (this.cashbooksLoading || (this.cashbooksLoaded && !force)) {
        return
      }

      this.cashbooksLoading = true
      this.cashbooksError = null

      this.$store.dispatch('vouchers/fetchCashflowCashbooks')
        .then(({ data }) => {
          const cashbooks = Array.isArray(data.data) ? data.data : []

          this.cashbookOptions = cashbooks.map(cashbook => ({
            label: `[${this.cashbookTypeLabel(cashbook.cashbook_type)}] ${cashbook.name}`,
            value: cashbook.id
          }))
          this.cashbooksLoaded = true
        })
        .catch(error => {
          this.cashbookOptions = []
          this.cashbooksLoaded = false
          this.cashbooksError = this.cashbookErrorMessage(error)
        })
        .then(() => {
          this.cashbooksLoading = false
        })
    },
    loadBankAccounts () {
      this.bankAccountsLoading = true
      this.$store.dispatch('vouchers/fetchCashflowBankAccounts')
        .then(({ data }) => {
          const accounts = Array.isArray(data.data) ? data.data : []
          this.bankAccountOptions = accounts.map(account => ({
            label: `[${account.bank ? account.bank.name : 'Bank'}] ${account.account_number} (${account.currency_type})`,
            value: account.id
          }))
        })
        .catch(() => { this.bankAccountOptions = [] })
        .then(() => { this.bankAccountsLoading = false })
    },
    add () {
      this.inputs.push(
        {
          account_id  : null,
          description : this.inputs[this.inputs.length - 1].description,
          debit       : 0,
          credit      : 0
        }
      )
    },
    remove (index) {
      this.inputs.splice(index, 1)
    },
    getAccounts () {
      const self        = this

      this.$store.dispatch('accounts/fetchAccounts', {
        company_id: this.company.id
      })
        .then(res => {
          const data = res.data.data
          data.forEach((value) => {
            if (!value.account_code.endsWith('000')) {
              self.accountOptions.push({
                label: `[${value.account_code}] ${value.name}`,
                value: value.id
              })
            }
          })

        })
        .catch(err => {
          this.$vs.notify({
            color: 'danger',
            title: 'Opps..',
            text: err
          })
        })
    },
    submitData () {
      const self = this


      this.$validator.validateAll().then(result => {
        if (result) {

          if (self.cashflowEnabled && self.cashflowTarget === 'cashbook' && !self.selectedCashflowCashbookId) {
            self.$vs.notify({
              color: 'warning',
              title: 'Cashbook belum dipilih',
              text: 'Pilih Buku Kas Cashflow.'
            })
            return
          }

          if (self.cashflowEnabled && self.cashflowTarget === 'bank_account' && !self.selectedBankAccountId) {
            self.$vs.notify({ color: 'warning', title: 'Account Bank belum dipilih', text: 'Pilih Account Bank Cashflow.' })
            return
          }

          if (self.cashflowEnabled && !['debit', 'credit'].includes(self.type)) {
            self.$vs.notify({
              color: 'warning',
              title: 'Jenis transaksi belum dipilih',
              text: 'Pilih Kas Masuk atau Kas Keluar.'
            })
            return
          }

          if (self.cashflowEnabled && !String(self.paidTo || '').trim()) {
            self.$vs.notify({
              color: 'warning',
              title: 'Paid To belum diisi',
              text: 'Isi penerima atau pembayar untuk Cashflow.'
            })
            return
          }

          if (self.cashflowEnabled && self.cashflowExtraItems.some(item => !String(item.title || '').trim() || item.amount === null || item.amount === '' || !Number.isSafeInteger(Number(item.amount)))) {
            self.$vs.notify({ color: 'warning', title: 'Item tambahan belum lengkap', text: 'Isi keterangan dan nominal bulat (boleh minus), atau hapus baris yang tidak digunakan.' })
            return
          }
          if (self.cashflowEnabled && self.cashflowTarget === 'bank_account' && self.debit + self.cashflowExtraTotal < 0) {
            self.$vs.notify({ color: 'warning', title: 'Total bank negatif', text: 'Item boleh minus, tetapi total Cashflow bank tidak boleh negatif.' })
            return
          }
          if (self.cashflowEnabled && !Number.isSafeInteger(self.debit + self.cashflowExtraTotal)) {
            self.$vs.notify({ color: 'warning', title: 'Total terlalu besar', text: 'Total Cashflow melebihi batas nominal yang didukung.' })
            return
          }

          const activeCompany = JSON.parse(localStorage.getItem('activeCompany'))

          if (self.debit !== self.credit) {
            self.$vs.notify({
              color: 'warning',
              title: 'Opps..',
              text: 'Debit dan Kredit tidak balance'
            })
          } else {

            const formData  = new FormData()

            formData.set('company_id', activeCompany.id)
            formData.set('no_voucher', `${self.fs_number}-${self.sc_number}`)
            formData.set('transaction_date', `${self.date}-${localStorage.getItem('selectedYear')}`.split('-').reverse().join('-'))
            formData.append('transactions',
              JSON.stringify(
                self.inputs.map(input => ({
                  account_id: input.account_id,
                  description: input.description,
                  debit: self.parseAmount(input.debit),
                  credit: self.parseAmount(input.credit)
                }))
              )
            )

            if (self.cashflowEnabled) {
              if (self.cashflowTarget === 'cashbook') formData.set('cashflow_cashbook_id', self.selectedCashflowCashbookId)
              else formData.set('cashflow_bank_account_id', self.selectedBankAccountId)
              formData.set('cashflow_type', self.type)
              formData.set('cashflow_paid_to', String(self.paidTo).trim())
              formData.set('cashflow_notes', String(self.cashflowNotes || '').trim())
              formData.set('cashflow_extra_items', JSON.stringify(self.cashflowExtraItems.map(item => ({ title: item.title.trim(), amount: Number(item.amount) }))))
            }

            // for (const value of formData.values()) {
            //   console.log(value);
            // }

            this.$store.dispatch('vouchers/createVoucher', formData)
              .then(function () {
                self.$vs.notify({
                  color: 'success',
                  title: 'Berhasil',
                  text: 'Voucher berhasil di tambahkan'
                })
                self.$router.push('/journal-vouchers')
              })
              .catch(err => {
                self.$vs.notify({
                  color: 'danger',
                  title: 'Opps..',
                  text: (err.response && err.response.data && err.response.data.message) || err.message || 'Voucher gagal disimpan.'
                })
              })
          }
        }
      })
    }
  },
  created () {
    if (!moduleAccount.isRegistered) {
      this.$store.registerModule('accounts', moduleAccount)
      moduleAccount.isRegistered = true
    }
    if (!moduleVoucher.isRegistered) {
      this.$store.registerModule('vouchers', moduleVoucher)
      moduleVoucher.isRegistered = true
    }
    this.getAccounts()
    this.loadCashflowCashbooks()
    this.loadBankAccounts()
  }
}
</script>

<style>
  .divider {
    background: #E0E0E0;
    height: 1px;
  }

  .cashflow-panel {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    padding: 16px;
  }

  .v-select .vs__dropdown-toggle {
    min-height: 38px;
  }

  .v-select .vs__dropdown-toggle .vs__selected {
    padding: 1px 4px;
  }

  .v-select .vs__dropdown-toggle .vs__search {
    position: absolute;
    width: 100%;
  }

  .v-select .vs__dropdown-toggle .vs__selected-options {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
